'use client';

import './not-found.css';

// This page renders when a route like `/unknown.txt` is requested.
// In this case, the layout at `app/[locale]/layout.tsx` receives
// an invalid value as the `[locale]` param and calls `notFound()`.

export default function GlobalNotFound() {
    return (
        <html lang='en'>
            <head>
                <meta charSet='UTF-8' />
                <meta name='viewport' content='width=device-width, initial-scale=1.0' />
                <title>404 - Milli Dadlar</title>
            </head>
            <body className='not-found-page'>
                <div className='logo-container'>
                    <img src='/svg/logo-light.svg' alt='Milli Dadlar Logo' width='139' height='22' />
                </div>
                <div className='pan-container'>
                    <img src='/svg/pan.svg' alt='Pan' className='pan-image' />
                    <a href='/' className='home-button'>
                        back home
                    </a>
                </div>
            </body>
        </html>
    );
}
